import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-activar-inactivar-option',
  templateUrl: './activar-inactivar-option.component.html',
  styleUrls: ['./activar-inactivar-option.component.scss']
})
export class ActivarInactivarOptionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
